module.exports = __webpack_public_path__ + "static/IPhone_App_Wizard_06-4d28c008363b6457e2681c753903928f.png";